import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../Service";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider } from "@material-ui/core";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%'
  },
  indicator: {
    backgroundColor: 'white',
  },

  selected: {
    backgroundColor: 'green !important',
  },
  formWrapper: {
    background: "#fff",
    width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "capitalize",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "center",
    "& button": {
      marginRight: "20px",
      //   height:'16px'
    },
  },
  tabStyle: {
    borderRadius: "7px", marginRight: '20px', height: '16px', textTransform: 'initial'
  }
}));



const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function ManageTemplate(props) {
  const theme = useTheme();
  const classes = useStyles();
  const { action, handleClose, data } = props;
  const [feildName, setFeildName] = useState("");
  const [openNewFeild, setOpenNewFeild] = useState("");
  // const message = useContext(ToastMessageContext);
  const [loading, setLoading] = useState(false);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [CRFOpen, setCRFOpen] = useState(false);
  const [feildValue, setFeildValue] = useState([]);

  const [userData, setUserData] = useState([]);
  const [value, setValue] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setFeildValue(data.module_form_fields);
  }, [feildValue]);
  const setOpen = () => {
    setOpenNewFeild("open");
    setOpenNewFeildDialog(true);
  };
  const handleNewFeildClose = () => {
    setOpenNewFeildDialog(false);
  };
  const onChangeItem = (selectedItemValue, inputId) => {
    console.log(selectedItemValue, inputId);
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const handleCreate = (formData) => {
    setLoading(true);
    DataService.createData({ ...userData }, "module_setups")
      .then((res) => {
        if (res.success) {
          handleClose(res.data);
          // message.showToastMessage({ open: true, message: "New Supplier added successfully", variant: "success" });
          props.moduleSetup();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ? res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch(() => {
        // message.showToastMessage({ open: true, message: "Something went wrong. Try Again", variant: "error" });
        setLoading(false);
      });
  };

  const handleUpdate = (formData) => { };

  const handleDeleteFeild = () => {
    setLoading(true);
    console.log(`feildName`, feildName);
    DataService.deleteDirectFeild(
      `/module_setups/delete_form_field?module_id=${props.moduleId}&field_name=${feildName}`
    )
      .then((res) => {
        if (res.success) {
          handleNewFeildClose(res.data);
          props.moduleSetup();
          // message.showToastMessage({ open: true, message: "New Supplier added successfully", variant: "success" });
          //   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ? res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch(() => {
        // message.showToastMessage({ open: true, message: "Something went wrong. Try Again", variant: "error" });
        setLoading(false);
      });
  };
  const setInputState = (inputStateValue, inputId) => {

    setUserData({ ...userData, [inputId]: inputStateValue })
  }
  const handleCreateNewFeild = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setLoading(true);
    DataService.createData({ module_id: props.moduleId, ...userData }, "module_setups_new_feild")
      .then((res) => {
        if (res.success) {
          handleNewFeildClose(res.data);

          props.moduleSetup();
          // message.showToastMessage({ open: true, message: "New Supplier added successfully", variant: "success" });
          //   props.getSupplierList();
        } else {
          // message.showToastMessage({ open: true, message: res.errors ? res.errors.join(',') : "Something went wrong. Try Again", variant: "error" });
          setLoading(false);
        }
      })
      .catch(() => {
        // message.showToastMessage({ open: true, message: "Something went wrong. Try Again", variant: "error" });
        setLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    for (const iterator of formData) {
      console.log(iterator);
    }

    if (action === "create") {
      handleCreate(formData);
      setCRFOpen(true);
    } else if (action === "edit") {
      handleUpdate(formData);
    }
  };

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth={"xl"}
        disableBackdropClick
        disableEscapeKeyDown
        style={{ height: '70%' }}
        open={true}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >

        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >

          <Grid
            container
            spacing={1}
            alignItems={"center"}
            justify={"flex-start"}
          >
            <Grid item xs={3}>
              Assignment Summary (Karen Fuge - 0320 - EC)
            </Grid>
            <Grid item xs={6}>
              Organization: SKY Corporation
            </Grid>
            <Grid item xs={3}>
              View Assignment Details
            </Grid>
            <Grid item xs={1}>

            </Grid>
          </Grid>

        </DialogTitle>
        <Divider />
        <DialogContent >
          <div style={{ marginTop: '5%' }} className={classes.root}>
            {/* <AppBar position="static" color="default"> */}
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              classes={{
                indicator: classes.indicator,
                selected: classes.selected
              }}
              aria-label="full width tabs example"
            >
              <Tab variant="contained" className={classes.tabStyle} label="Session details" {...a11yProps(0)} />
              <Tab className={classes.tabStyle} label="Coaching agreement form" {...a11yProps(1)} />
              <Tab className={classes.tabStyle} label="Leadership competency" {...a11yProps(2)} />
              <Tab className={classes.tabStyle} label="Evaluation form" {...a11yProps(3)} />
              <Tab className={classes.tabStyle} label="Costs" {...a11yProps(4)} />
              <Tab className={classes.tabStyle} label="SLA" {...a11yProps(5)} />
            </Tabs>
            {/* </AppBar> */}

            <TabPanel value={value} index={0} dir={theme.direction}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              Item Two
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction}>
              Item four
            </TabPanel>
          </div>
        </DialogContent>
      </Dialog>
      )
    </div>
  );
}

export default ManageTemplate;
